// ディクテーション（書き取り）の成績永続化。デスクトップ版 src/dictation.js と同じデータ形：
//   progress = { [sentenceIndex]: { attempts, best, last, lastAt } }
//   best/last は正答率(0-100)、lastAt は ISO 文字列。
// PWA では item(contentHash) ごとに IndexedDB の kv ストアへ保存する（key = `dictation:<hash>`）。
// 文インデックスは字幕(=作成後不変)由来なので実用上安定（デスクトップと同じ前提）。
//
// 【既知の制約】クラウド同期(Google Drive)は未対応＝この端末ローカルのみ。
//   デスクトップは dictation.json を R2 経由で双方向同期＋tombstone を持つが、PWA は当面ローカル保存。
//   将来 Drive 同期に乗せるなら kv 値をそのままドキュメント化して hash キーでマージ（vocab と同型）にできる。
import { kvGet, kvSet } from './db.js'

const keyFor = (hash) => `dictation:${hash}`

// 指定アイテムの成績マップ { [idx]: {attempts,best,last,lastAt} } を返す（無ければ空）。
export async function getProgress(hash) {
  if (!hash) return {}
  try {
    return (await kvGet(keyFor(hash))) || {}
  } catch {
    return {}
  }
}

// 1文の採点結果を記録。戻り値は更新後のその文のエントリ。
export async function record(hash, index, accuracy) {
  if (!hash || index == null) return null
  const acc = Math.max(0, Math.min(100, Math.round(Number(accuracy) || 0)))
  const all = await getProgress(hash)
  const prev = all[index] || { attempts: 0, best: 0, last: 0, lastAt: null }
  const entry = {
    attempts: (prev.attempts || 0) + 1,
    best: Math.max(prev.best || 0, acc),
    last: acc,
    lastAt: new Date().toISOString(),
  }
  all[index] = entry
  try {
    await kvSet(keyFor(hash), all)
  } catch {
    /* 保存できなくても採点結果は返す */
  }
  return entry
}

// アイテムの履歴を全消去（音源削除時などに使用可能）。
export async function clearProgress(hash) {
  if (!hash) return { ok: false }
  try {
    await kvSet(keyFor(hash), {})
  } catch {
    /* noop */
  }
  return { ok: true }
}
